export var EcommItemType;

(function (EcommItemType) {
  EcommItemType["PRODUCT"] = "product";
  EcommItemType["EVENT"] = "event";
})(EcommItemType || (EcommItemType = {}));